<template>
  <div v-if="loaded">
    <Modal
      ref="modal"
      title="Onboard candidate"
      :body="body"
      action="Onboard"
      actionColor="green"
      @closeModal="handleCancel"
      @handleAction="handleOnboard"
    >
      <div v-if="onboardingChecklists.length > 0" class="py-4">
        <FormKit
          type="select"
          label="Onboarding Checklist"
          v-model="selectedChecklist"
          :options="onboardingChecklistOptions"
          placeholder="Select an onboarding checklist"
        />
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from '../shared/Modal.vue';

export default {
  props: ['record'],
  components: {
    Modal,
  },
  data() {
    return {
      onboardingChecklists: [],
      selectedChecklist: null,
      loaded: false,
    };
  },
  async mounted() {
    await this.fetchOnboardingChecklists();
    this.loaded = true;
  },
  methods: {
    async fetchOnboardingChecklists() {
      const res = await fetch('/api/task_checklists?checklist_type=onboarding');
      const { records } = await res.json();
      this.onboardingChecklists = records;
    },
    handleOnboard() {
      const self = this;
      fetch(`/api/contacts/${self.$route.params.id}/onboard`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
        body: JSON.stringify({
          task_checklist_id: self.selectedChecklist,
        }),
      })
        .then(response => response.json())
        .then(data => {
          if (data.status != 'error') {
            self.$emit('handleContactOnboard');
            self.$refs.modal.success();
            self.$store.commit('general/showAlert', {
              alertType: 'success',
              alertTitle: 'Contact onboarding started',
              alertDescription:
                'Your contact has successfully started onboarding.  Use the button below to dismiss this alert.',
            });
          } else {
            self.$refs.modal.error();
            self.$store.commit('general/showAlert', {
              alertType: 'error',
              alertTitle: 'Contact onboarding error',
              alertDescription: data.message,
            });
          }
        });
    },
    handleCancel() {
      this.$emit('handleContactOnboardCancel');
    },
  },
  computed: {
    body() {
      if (this.record.stage == 'Onboarding') {
        return "This candidate has already been sent to onboarding. Clicking Onboard again will regenerate their agreement which is useful if you've updated any of their details. If you don't want to regenerate a new agreement, please click cancel.";
      } else {
        return 'Are you sure you want to onboard this candidate? Onboarding will send them an email to begin the process of joining your brokerage/team.';
      }
    },
    onboardingChecklistOptions() {
      return this.onboardingChecklists.map(({ id, name }) => {
        return { value: id, label: name };
      });
    },
  },
};
</script>
